import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fail",
  "use": "fail-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"fail\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <circle cx=\"24\" cy=\"24\" r=\"24\" fill=\"#FFAB00\" />\n        <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M21 27V12h6v15h-6zm0 9v-4.5h6V36h-6z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol